import createElement from './createElement';
// Global helpers
import api from '../core/utils/api';
import handleError from '../core/utils/handleError';
import rememberMeActionWrapper from '../visual-components/rememberMe-actions';
var replyCard = function (config, section, item, personId) {
    var wrapper = createElement('div');
    var onSubmit = function (type, _a) {
        var write = _a.write;
        var payload = {
            comment: write.message,
            first_name: write.firstName,
            last_name: write.lastName,
            email: write.email,
            public: true,
            type: 'condolence',
        };
        var tabs = wrapper.querySelector('._msnlq-tabs');
        var content = wrapper.querySelector('._msnlq-tabs-contentblocks');
        // Send the reply
        api.post("/person/".concat(personId, "/interaction/").concat(item.id), payload, {
            'X-Widget-Id': config._id,
            // 'X-Widget-Filter': section.municipality ?? null,
            'X-Widget-Instance-Id': config._widgetInstanceId,
            'X-Customer-Id': config._customerId,
            'X-Uri': window.location.href,
        })
            .then(function () {
            wrapper
                .querySelector('._msnlq-ae-s-me')
                .setAttribute('style', 'display: block;');
            wrapper
                .querySelector('._msnlq-ae-e-me')
                .setAttribute('style', 'display: none;');
            // Hide the contentform
            tabs.setAttribute('style', 'display: none;');
            content.setAttribute('style', 'display: none;');
        })
            .catch(function () {
            wrapper
                .querySelector('._msnlq-ae-e-me')
                .setAttribute('style', 'display: block;');
            // Log the error
            handleError({
                section: 'Condolence - Reply',
                message: "Post request failed",
                payload: payload,
            });
        });
    };
    wrapper.appendChild(rememberMeActionWrapper(config, section, onSubmit, true, item));
    return wrapper;
};
export default replyCard;
